import type { AvatarComponentProps } from './types';
import videoAvatar from 'Assets/images/video-avatar.jpg';
import { UserAvatar } from 'Components/shared/UserAvatar';
import React from 'react';
import { Image } from 'semantic-ui-react';
import { Styled } from './index.styles';

export const Avatar: React.FC<AvatarComponentProps> = ({
  message,
  person,
  conversationId,
  selectPersonPresenceStatus,
  variant = '',
  isInactive = false,
}) => {
  if (variant === 'phone') {
    if (person?.avatarUrl) {
      return (
        <UserAvatar
          name={person?.name}
          conversationId={conversationId}
          isInactive={isInactive}
          image={person?.avatarUrl}
        />
      );
    }

    return (
      <Styled.PhoneContainer>
        <Styled.PhoneIcon size="small" icon="phone" />
      </Styled.PhoneContainer>
    );
  }

  if (message.systemEvent?.source?.includes('Voxeet')) {
    return <Image src={videoAvatar} size="mini" />;
  }

  return (
    <UserAvatar
      name={person?.name}
      conversationId={conversationId}
      presence={
        person?.sourceId
          ? selectPersonPresenceStatus(person.sourceId)
          : undefined
      }
      isInactive={isInactive}
      image={person?.avatarUrl}
    />
  );
};
